import * as React from 'react'
import {ActivityIndicator} from 'antd-mobile'
import * as styles from './style/index.scss'
import intl from '@utils/intl';

export default ({toast = true, animating = false}) => (
    <div className={styles.loadingWrap}>
        <ActivityIndicator
            toast={toast}
            text={intl.formatMessage({id: 'common.loading.loading1'})}
            animating={animating}
        />
    </div>
)
